// TODO: Blur-647 This assets types are only for Marine but would be a very good idea use it for every single vertical
import { NADAAccessory } from 'api/vehicles/postNADAAccessories'

export interface BaseAssetDTO {
    condition: string
    year?: number
    make?: string
    model?: string
}

export interface AutomobileAssetDTO extends BaseAssetDTO {
    automobile_id?: number | null
    trim?: string
    color?: string
    nada_accessories?: NADAAccessory[]
    invoice_price?: number
    booking_source?: string
    is_cpo?: boolean
    mileage?: number | string | null
    wholesale_price?: number
    like_invoice_price?: number
    boat_type?: string
    hours?: number
    length_ft?: number
    horsepower?: number
    engine_type?: string
    name?: string
    description?: string
    sales_price?: number
}

export interface AutomobileCollateralDTO {
    asset: AutomobileAssetDTO
    asset_type: string
    asset_value: number
    data_source: string
    asset_subtype?: string
    unique_external_id?: string
}

export interface MakeTitleInformationDTO {
    has_title: boolean
    no_title_reason?: string
    no_title_other_reason?: string
}

export interface RvAssetDTO extends BaseAssetDTO {
    rv: number
    rv_type: string
    manufacturer_price: string
    wholesale_price: string
    retail_price: string
    mileage?: number
    oem?: string
    name: string
    title_information?: MakeTitleInformationDTO
}

type nullableString = string | null

export interface RvCollateralDTO {
    asset: RvAssetDTO
    asset_type: string
    asset_subtype?: string
    asset_name: string
    asset_value: nullableString
    data_source: string
    unique_external_id?: string
    application: number
    is_auto_generated: boolean
}

export interface OpeAssetDTO extends BaseAssetDTO {
    equipment_type?: string
    equipment_sub_type?: string
    msrp: number | null
    oem?: string | null
    outdoor_power_equipment: number
    sku: string | null
}

export interface OpeCollateralDTO {
    asset: OpeAssetDTO
    asset_type: string
    asset_value: number | null
    asset_sales_price: number | null
    data_source: string
    unique_external_id?: string
}

interface MarineEngineAssetDTO extends BaseAssetDTO {
    invoice_price?: number
    horsepower?: number
    engine_type: string
    fuel_type?: string
    hours?: number
}

interface MarineTrailerAssetDTO extends BaseAssetDTO {
    sales_price?: number
    weight?: number
}

interface MarineHullAssetDTO extends BaseAssetDTO {
    type?: string
    invoice_price?: number
    oem?: string
    boat_type?: string
    length_ft?: number
    hours?: number
}

export type MarineAssetDTO =
    | MarineEngineAssetDTO
    | MarineHullAssetDTO
    | MarineTrailerAssetDTO

export interface BaseMarineCollateralDTO<E extends MarineAssetDTO> {
    asset: E
    asset_type: string
    asset_value: number
    data_source: string
    asset_subtype?: string
}

export type MarineHullCollateralDTO =
    BaseMarineCollateralDTO<MarineHullAssetDTO>
export type MarineEngineCollateralDTO =
    BaseMarineCollateralDTO<MarineEngineAssetDTO>
export type MarineTrailerCollateralDTO =
    BaseMarineCollateralDTO<MarineTrailerAssetDTO>
export type MarineCollateralDTO =
    | MarineHullCollateralDTO
    | MarineEngineCollateralDTO
    | MarineTrailerCollateralDTO

export type CollateralsDTO =
    | AutomobileCollateralDTO
    | RvCollateralDTO
    | OpeCollateralDTO
    | MarineCollateralDTO

export interface PostCollateralsAssetsDTO<E extends CollateralsDTO> {
    collateral: E[]
}

export class ApplicationSubmissionTimeoutError extends Error {}

export class ApplicationSubmissionError extends Error {}

export interface DecisionResult {
    applicationStatus: string
    asyncSubmission: boolean
    applicationId?: number
}
